export default __webpack_public_path__ + "static/media/km.1d627348.svg";